import type { UsageTypeID } from '../types/db.ts';

export const UsageTypeIds = {
  Manufactured: 0 as UsageTypeID,
  Processed: 1 as UsageTypeID,
  'Otherwise Used': 2 as UsageTypeID,
};

export const UsageTypeNames: Record<UsageTypeID, string> = {
  [UsageTypeIds.Manufactured]: 'Manufactured',
  [UsageTypeIds.Processed]: 'Processed',
  [UsageTypeIds['Otherwise Used']]: 'Otherwise Used',
};
